import { CSRF_TOKEN, URL_PREFIX } from "../constants";

/**
 * Функция запроса к серверу
 * @param  {Object} params - параметры запроса
 * {
 *   url {String},
 *   addCSRFToken {Boolean},
 *   data {object},
 *   async {Boolean},
 *   type {String},
 *   timeout {Number},
 *   needOverlay {Boolean},
 *   parseJSON {Boolean},
 * }
 * @return {Promise}
 */
export default (params) => {

  /* по умолчанию показываем прелоадер */
  if (params.needOverlay !== false) params.needOverlay = true;

  /* Если определен URL_PREFIX То добавить префикс перед url */
  if (URL_PREFIX) params.url = URL_PREFIX + params.url;

  /* Если надо передать токен */
  if (params.addCSRFToken && params.data) params.data["_csrf-frontend"] = CSRF_TOKEN;

  return new Promise((succeed, fail) => {
    $.ajax({
      url: params.url,
      data: params.data || null,
      async: params.async || true,
      type: params.type || "POST",
      timeout: params.timeout || 40000,
      beforeSend: () => {
        if (params.needOverlay) return $("#js-overlay").show();
      },
      success: response => {
		  if (!response) return succeed();
        if (params.parseJSON === false) return succeed(response);

        try {
          succeed(JSON.parse(response));
        } catch (e) {
          succeed(response);
        }
      },
      error: error => fail(new Error(`Request failed: ${error.statusText}`)),
      complete: () => {
        if (params.needOverlay) return $("#js-overlay").hide()
      }
    });
  });
};
